export default __webpack_public_path__ + "static/media/design2.65b1a289.png";